
/* Skyla Rose Fitting Room v3 — front-end. Markup and styles live in snippets/saro-try-on.liquid */
/* v6: "Build a model" for shoppers who'd rather not upload a photo (adults only) */
/* v6: hooks for the "Style my look" add-on (saro-tryon-style.js, loaded below) */
(function(){
var SARO_ME = document.currentScript;
window.SARO_TRYON_ASSETS = SARO_ME && SARO_ME.src ? SARO_ME.src.replace(/saro-try-on\.js.*$/, '') : '';
// Theme CSS can override the [hidden] attribute on buttons, so enforce it inside the fitting room
if (!document.getElementById('saro-tryon-hidden-fix')) {
  var st = document.createElement('style'); st.id = 'saro-tryon-hidden-fix';
  st.textContent = '.saro-tryon [hidden]:not(.saro-tryon__back){display:none !important}';
  document.head.appendChild(st);
}
function initTryOn(root){
  if (!root || root.dataset.ready) return; root.dataset.ready = '1';
  var section = root.closest('.product-section') || document;
  var priceBlock = section.querySelector('.product-block--price');
  if (priceBlock) priceBlock.insertAdjacentElement('afterend', root);
  var api = root.dataset.api, garment = root.dataset.garment;
  var sizes = root.dataset.sizes ? root.dataset.sizes.split('|') : [];
  var fit = root.dataset.fit;
  var kids = root.dataset.kids === 'true';
  var $ = function(s){ return root.querySelector(s); };
  var overlay = $('.saro-tryon__overlay'), back = $('.saro-tryon__back');
  var agree = $('.saro-tryon__agree'), go = $('.saro-tryon__go');
  var drop = $('.saro-tryon__drop'), stage = $('.saro-tryon__stage'), cv = $('.saro-tryon__canvas');
  var blurT = $('.saro-tryon__blurtoggle'), blurRow = $('.saro-tryon__blur'), blurMsg = $('.saro-tryon__blurmsg');
  var brushBtn = $('.saro-tryon__brush'), undoBtn = $('.saro-tryon__undo');
  var mode = 'body', photo = null, lookImg = null, videoUrl = null, history = [];
  // Blur state. Boxes are stored as fractions of the photo (x, y, w, h from 0 to 1)
  var src = null, faces = [], manual = [], detecting = false, brushOn = false;
  var sentBlur = false, sentBoxes = [], sentAspect = 1, lookBoxes = [], lookAspect = 1;
  var CONSENT_V = 'v1.1';  // v1.1: partner no longer named in the checkbox text

  // Remember the shopper's photo/twin for this browsing session only, so they can try other dresses
  function store(k, v){ try { v === null ? sessionStorage.removeItem(k) : sessionStorage.setItem(k, v); } catch(e){} }
  function recall(k){ try { return sessionStorage.getItem(k); } catch(e){ return null; } }

  function show(step, noHistory){
    root.querySelectorAll('.saro-tryon__step').forEach(function(s){ s.hidden = s.dataset.step !== step; });
    if (!noHistory) history.push(step);
    back.hidden = history.length < 2 || step === 'loading';
    $('.saro-tryon__dialog').scrollTop = 0;
  }
  function blurOn(){ return mode !== 'selfie' && blurT.checked; }
  function blurOK(){ return !blurOn() || (!detecting && (faces.length + manual.length) > 0); }
  function ready(){ go.disabled = !(photo && agree.checked && blurOK()); }
  function fail(msg){ $('.saro-tryon__errmsg').textContent = msg || 'Please try a clear photo in good light.'; show('error'); }
  function loading(title, sub){ $('.saro-tryon__loadmsg').textContent = title; $('.saro-tryon__loadsub').textContent = sub; show('loading', true); }
  function close(){ overlay.hidden = true; document.body.style.overflow = ''; var v = $('.saro-tryon__video'); v.pause(); stopBlurred(); }
  function track(name){ try { if (window.Shopify && Shopify.analytics) Shopify.analytics.publish(name, { product: root.dataset.product }); } catch(e){} }

  function post(path, body){
    return fetch(api + path, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(body) })
      .then(function(r){ return r.json(); });
  }
  function poll(id, maxTries){
    return new Promise(function(resolve, reject){
      var tries = 0;
      (function tick(){
        if (++tries > maxTries) return reject('This is taking longer than usual. Please try again.');
        fetch(api + '/status/' + id).then(function(r){ return r.json(); }).then(function(s){
          if (s.status === 'completed' && s.output) resolve(s.output);
          else if (s.status === 'failed') reject(s.error);
          else setTimeout(tick, 1500);
        }).catch(function(){ setTimeout(tick, 2500); });
      })();
    });
  }
  function asDataUrl(out, type){
    if (out.indexOf('data:') === 0 || out.indexOf('http') === 0) return out;
    return 'data:' + (type || 'image/jpeg') + ';base64,' + out;
  }
  // Redraw the photo onto a fresh canvas (max 1536px). This also strips all EXIF/GPS/device data.
  function shrink(file, cb){
    var img = new Image(), reader = new FileReader();
    reader.onload = function(){ img.src = reader.result; };
    img.onload = function(){
      var max = 1536, s = Math.min(1, max / Math.max(img.width, img.height));
      var c = document.createElement('canvas');
      c.width = Math.round(img.width * s); c.height = Math.round(img.height * s);
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      cb(c);
    };
    reader.readAsDataURL(file);
  }

  // ---- On-device face blur (nothing unblurred leaves the phone when blur is on)
  var MPV = 'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14';
  var MODEL = 'https://storage.googleapis.com/mediapipe-models/face_detector/blaze_face_short_range/float16/1/blaze_face_short_range.tflite';
  var detP = {};
  // Built at runtime so Shopify's script minifier leaves the dynamic import alone
  var dynImport = new Function('u', 'return import(u)');
  function detector(runMode){
    if (!detP[runMode]) {
      detP[runMode] = dynImport(MPV + '/vision_bundle.mjs').then(function(m){
        return m.FilesetResolver.forVisionTasks(MPV + '/wasm').then(function(fs){
          return m.FaceDetector.createFromOptions(fs, { baseOptions: { modelAssetPath: MODEL }, runningMode: runMode, minDetectionConfidence: 0.5 });
        });
      });
      detP[runMode].catch(function(){ detP[runMode] = null; });
    }
    return detP[runMode];
  }
  function clamp01(b){
    var x = Math.max(0, b.x), y = Math.max(0, b.y);
    return { x: x, y: y, w: Math.min(1, b.x + b.w) - x, h: Math.min(1, b.y + b.h) - y };
  }
  // 25% padding left and right, extra up top for the hairline, and only a little below the chin so the neckline stays visible
  function padBox(b){ return clamp01({ x: b.x - b.w * 0.25, y: b.y - b.h * 0.4, w: b.w * 1.5, h: b.h * 1.5 }); }
  function overlap(a, b){
    var ix = Math.max(0, Math.min(a.x + a.w, b.x + b.w) - Math.max(a.x, b.x));
    var iy = Math.max(0, Math.min(a.y + a.h, b.y + b.h) - Math.max(a.y, b.y));
    return (ix * iy) / Math.min(a.w * a.h, b.w * b.h);
  }
  function merge(list){
    var out = [];
    list.forEach(function(b){
      for (var i = 0; i < out.length; i++) {
        if (overlap(out[i], b) > 0.3) {
          var o = out[i], x = Math.min(o.x, b.x), y = Math.min(o.y, b.y);
          out[i] = { x: x, y: y, w: Math.max(o.x + o.w, b.x + b.w) - x, h: Math.max(o.y + o.h, b.y + b.h) - y };
          return;
        }
      }
      out.push(b);
    });
    return out;
  }
  // Scan the whole photo plus overlapping zoomed tiles, so small faces in full-length photos are found too
  function findFaces(canvas){
    return detector('IMAGE').then(function(d){
      var W = canvas.width, H = canvas.height, found = [], tiles = [[0, 0, W, H]];
      var s = Math.round(Math.min(W, H) * 0.5), step = Math.round(s * 0.5);
      for (var y = 0; y < H - step; y += step) for (var x = 0; x < W - step; x += step) tiles.push([x, y, Math.min(s, W - x), Math.min(s, H - y)]);
      var t = document.createElement('canvas'), tc = t.getContext('2d');
      tiles.forEach(function(r){
        var sc = 640 / Math.max(r[2], r[3]);
        t.width = Math.round(r[2] * sc); t.height = Math.round(r[3] * sc);
        tc.drawImage(canvas, r[0], r[1], r[2], r[3], 0, 0, t.width, t.height);
        (d.detect(t).detections || []).forEach(function(f){
          var b = f.boundingBox;
          found.push({ x: (r[0] + b.originX / sc) / W, y: (r[1] + b.originY / sc) / H, w: b.width / sc / W, h: b.height / sc / H });
        });
      });
      return merge(found).map(padBox);
    });
  }
  // Strong, irreversible blur: shrink each area to a few pixels, scale back up smoothly, then blur again
  function blurBoxes(ctx, boxes){
    var W = ctx.canvas.width, H = ctx.canvas.height, tmp = document.createElement('canvas'), tc = tmp.getContext('2d');
    boxes.forEach(function(b){
      var x = Math.floor(b.x * W), y = Math.floor(b.y * H), w = Math.ceil(b.w * W), h = Math.ceil(b.h * H);
      if (w < 2 || h < 2) return;
      tmp.width = 6; tmp.height = Math.max(3, Math.round(6 * h / w));
      tc.imageSmoothingEnabled = true;
      tc.drawImage(ctx.canvas, x, y, w, h, 0, 0, tmp.width, tmp.height);
      ctx.save(); ctx.beginPath(); ctx.rect(x, y, w, h); ctx.clip();
      ctx.imageSmoothingEnabled = true;
      if ('filter' in ctx) ctx.filter = 'blur(' + Math.max(6, Math.round(w / 8)) + 'px)';
      ctx.drawImage(tmp, 0, 0, tmp.width, tmp.height, x - w * 0.1, y - h * 0.1, w * 1.2, h * 1.2);
      ctx.restore();
    });
  }
  function allBoxes(){ return faces.concat(manual); }
  function render(){
    if (!src) return;
    cv.width = src.width; cv.height = src.height;
    var ctx = cv.getContext('2d');
    ctx.drawImage(src, 0, 0);
    if (blurOn()) blurBoxes(ctx, allBoxes());
    photo = cv.toDataURL('image/jpeg', 0.9);
    // Messages / tools
    var on = blurOn();
    brushBtn.hidden = !on; undoBtn.hidden = !on || !manual.length;
    if (!on) { blurMsg.hidden = true; }
    else if (detecting) { blurMsg.hidden = false; blurMsg.className = 'saro-tryon__blurmsg'; blurMsg.textContent = 'Finding faces to blur…'; }
    else if (!allBoxes().length) { blurMsg.hidden = false; blurMsg.className = 'saro-tryon__blurmsg is-warn'; blurMsg.textContent = 'We couldn\'t find a face to blur. Tap the photo to blur an area yourself, or choose a different photo.'; }
    else { blurMsg.hidden = false; blurMsg.className = 'saro-tryon__blurmsg'; blurMsg.textContent = (faces.length ? faces.length + (faces.length > 1 ? ' faces' : ' face') + ' blurred. ' : '') + 'Missed one? Tap the photo to blur another area.'; }
    ready();
  }
  function detectAndRender(){
    if (!src) return;
    if (!blurOn()) return render();
    detecting = true; render();
    var mine = src;
    findFaces(src).then(function(b){ if (mine === src) faces = b; })
      .catch(function(){ if (mine === src) faces = []; })
      .then(function(){ if (mine === src) { detecting = false; render(); } });
  }
  function setPhoto(canvas){
    src = canvas; faces = []; manual = []; brushOn = false; brushBtn.classList.remove('is-active');
    drop.hidden = true; stage.hidden = false;
    if (mode === 'selfie') { photo = canvas.toDataURL('image/jpeg', 0.88); cv.width = src.width; cv.height = src.height; cv.getContext('2d').drawImage(src, 0, 0); blurMsg.hidden = true; brushBtn.hidden = true; undoBtn.hidden = true; ready(); return; }
    detectAndRender();
  }
  cv.addEventListener('click', function(e){
    if (!src || !blurOn()) return;
    var r = cv.getBoundingClientRect(), px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
    var ref = faces[0], w = ref ? ref.w : 0.16, h = ref ? ref.h : 0.16 * src.width / src.height;
    manual.push(clamp01({ x: px - w / 2, y: py - h / 2, w: w, h: h }));
    render();
  });
  brushBtn.addEventListener('click', function(){
    brushOn = !brushOn; brushBtn.classList.toggle('is-active', brushOn);
    blurMsg.hidden = false; blurMsg.className = 'saro-tryon__blurmsg'; blurMsg.textContent = 'Tap anywhere on the photo to blur that area.';
  });
  undoBtn.addEventListener('click', function(){ manual.pop(); render(); });
  $('.saro-tryon__change').addEventListener('click', function(){
    src = null; photo = null; faces = []; manual = []; stage.hidden = true; drop.hidden = false; ready();
  });
  blurT.addEventListener('change', function(){ if (blurT.checked && src && !faces.length && !detecting) detectAndRender(); else render(); });

  // Blur the same areas on a finished image (try-on result), returned as a data URL
  // If the result has a different shape from the photo we sent, the saved boxes won't line up, so detect instead
  function sameShape(w, h){ return Math.abs(w / h - sentAspect) < 0.03; }
  function reblur(dataUrl, boxes){
    return new Promise(function(resolve){
      var img = new Image();
      img.onload = function(){
        var c = document.createElement('canvas'); c.width = img.width; c.height = img.height;
        var ctx = c.getContext('2d'); ctx.drawImage(img, 0, 0);
        var use = sameShape(img.width, img.height) ? boxes : [];
        findFaces(c).catch(function(){ return []; }).then(function(found){
          lookBoxes = use.concat(found); lookAspect = img.width / img.height;
          blurBoxes(ctx, lookBoxes);
          resolve(c.toDataURL('image/jpeg', 0.92));
        });
      };
      img.onerror = function(){ resolve(dataUrl); };
      img.src = dataUrl;
    });
  }

  // "See it move" with blur: draw each video frame onto a canvas and blur faces live
  var vRun = 0;
  function playBlurred(){
    var vid = $('.saro-tryon__video'), vc = $('.saro-tryon__vcanvas'), ctx = vc.getContext('2d'), run = ++vRun, live = [], n = 0, vdet = null;
    detector('VIDEO').then(function(d){ vdet = d; }).catch(function(){});
    vid.classList.add('is-offscreen'); vid.hidden = false; vc.hidden = false;
    (function frame(){
      if (run !== vRun || vc.hidden) return;
      if (vid.videoWidth) {
        if (vc.width !== vid.videoWidth) { vc.width = vid.videoWidth; vc.height = vid.videoHeight; }
        ctx.drawImage(vid, 0, 0, vc.width, vc.height);
        if (vdet && (n++ % 2 === 0)) {
          try {
            var res = vdet.detectForVideo(vc, performance.now());
            live = (res.detections || []).map(function(f){ var b = f.boundingBox; return padBox({ x: b.originX / vc.width, y: b.originY / vc.height, w: b.width / vc.width, h: b.height / vc.height }); });
          } catch(e){ vdet = null; }
        }
        // Always blur where the face was in the photo, widened side to side (the video mostly moves left and right)
        // but barely lower, so the top of the garment stays visible. Plus anything detected live.
        blurBoxes(ctx, (Math.abs(vc.width / vc.height - lookAspect) < 0.03 ? lookBoxes : []).map(function(b){ return clamp01({ x: b.x - b.w * 0.3, y: b.y - b.h * 0.12, w: b.w * 1.6, h: b.h * 1.15 }); }).concat(live));
      }
      requestAnimationFrame(frame);
    })();
  }
  function stopBlurred(){ vRun++; var vc = $('.saro-tryon__vcanvas'); vc.hidden = true; $('.saro-tryon__video').classList.remove('is-offscreen'); }

  function consentRecord(){
    return { v: CONSENT_V, who: kids ? 'my_child' : 'me', blur: sentBlur, mode: mode, session: session, product: root.dataset.product };
  }
  var session = recall('saro_session') || (Date.now().toString(36) + Math.random().toString(36).slice(2, 10));
  store('saro_session', session);

  // --- Open / close / back
  $('.saro-tryon__open').addEventListener('click', function(){
    overlay.hidden = false; document.body.style.overflow = 'hidden'; history = [];
    track('saro_try_on_opened');
    if (kids) { selectMode('body'); return; }
    $('.saro-tryon__reuse').hidden = !recall('saro_person');
    show('choose');
  });
  $('.saro-tryon__close').addEventListener('click', close);
  overlay.addEventListener('click', function(e){ if (e.target === overlay) close(); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !overlay.hidden) close(); });
  back.addEventListener('click', function(){ history.pop(); var prev = history.pop(); if (prev) show(prev); });

  // --- 1. Choose style
  function selectMode(m){
    mode = m;
    $('.saro-tryon__tip').textContent = mode === 'selfie'
      ? 'Take a clear, front-facing selfie in good light, with your hair off your face. We\'ll create a full-length AI twin of you.'
      : kids
        ? 'Stand your little one front-on, head to toe in frame, in good light. A plain background gives the best result.'
        : 'Stand front-on, head to toe in frame, in good light. Fitted clothing and a plain background give the best result.';
    $('.saro-tryon__height').hidden = mode !== 'selfie';
    var cam = $('.saro-tryon__file--cam');
    cam.setAttribute('capture', mode === 'selfie' ? 'user' : 'environment');
    src = null; photo = null; faces = []; manual = []; detecting = false;
    stage.hidden = true; drop.hidden = false; agree.checked = false;
    blurRow.hidden = mode === 'selfie'; blurT.checked = kids;
    if (blurT.checked) detector('IMAGE');  // start loading face detection early
    ready();
    show('upload');
  }
  root.querySelectorAll('.saro-tryon__card').forEach(function(card){
    card.addEventListener('click', function(){
      if (card.dataset.mode === 'model') return openBuild();
      selectMode(card.dataset.mode);
    });
  });
  $('.saro-tryon__reuse').addEventListener('click', function(){
    var meta = {}; try { meta = JSON.parse(recall('saro_person_meta') || '{}'); } catch(e){}
    sentBlur = !!meta.blur; sentBoxes = meta.boxes || []; sentAspect = meta.aspect || 1;
    runTryOn(recall('saro_person'));
  });

  // --- 2. Upload
  root.querySelectorAll('.saro-tryon__file').forEach(function(input){
    input.addEventListener('change', function(){
      var f = input.files && input.files[0]; if (!f) return;
      shrink(f, setPhoto);
      input.value = '';
    });
  });
  agree.addEventListener('change', ready);

  go.addEventListener('click', function(){
    if (!blurOK()) return;
    sentBlur = blurOn(); sentBoxes = sentBlur ? allBoxes().slice() : []; sentAspect = src ? src.width / src.height : 1;
    if (mode === 'body') {
      if (!kids) { store('saro_person', photo); store('saro_person_meta', JSON.stringify({ blur: sentBlur, boxes: sentBoxes, aspect: sentAspect })); }
      return runTryOn(photo);
    }
    // Selfie -> AI twin -> try-on
    var h = parseInt($('.saro-tryon__h').value, 10);
    if (h) $('.saro-tryon__h2').value = h;
    loading('Creating your AI twin…', 'This can take up to a minute. You only do this once.');
    post('/twin', { photo: photo, height: h || null, consent: consentRecord() })
      .then(function(d){ if (!d.id) throw d.error; return poll(d.id, 90); })
      .then(function(out){ var twin = asDataUrl(out); store('saro_person', twin); store('saro_person_meta', '{}'); track('saro_twin_created'); runTryOn(twin); })
      .catch(function(err){ fail(typeof err === 'string' ? err : null); });
  });

  // --- Build a model (adults only, no photo needed)
  var B_OPTS = {
    shape: { woman: [['slim','Slim'],['athletic','Athletic'],['curvy','Curvy'],['fuller','Fuller figure']],
             man:   [['slim','Slim'],['athletic','Athletic'],['broad','Broader build']] },
    height: { woman: [['petite','Petite','under 160cm'],['average','Average','160–170cm'],['tall','Tall','over 170cm']],
              man:   [['short','Shorter','under 175cm'],['average','Average','175–185cm'],['tall','Tall','over 185cm']] },
    skin: [['s1','#f3dccd'],['s2','#e8c3a4'],['s3','#d6a47c'],['s4','#b98157'],['s5','#8c5a3a'],['s6','#57382a']],
    hair: [['blonde','Blonde'],['brunette','Brunette'],['black','Black'],['red','Red']],
    size: { woman: ['2XS','XS','S','M','L','XL','2XL','3XL'], man: ['XS','S','M','L','XL','2XL','3XL'] }
  };
  var unisex = root.dataset.unisex === 'true';
  var pick = { gender: 'woman' };
  var buildStep = $('.saro-tryon__step[data-step="build"]');
  function normSize(s){
    s = String(s || '').trim().toUpperCase().split(/[\s\/]/)[0];
    return { XXS: '2XS', XXL: '2XL', XXXL: '3XL' }[s] || s;
  }
  // Only offer the sizes this product actually comes in
  function sizeList(){
    var all = B_OPTS.size[pick.gender];
    var mine = sizes.map(normSize).filter(function(s){ return all.indexOf(s) > -1; });
    return mine.length ? all.filter(function(s){ return mine.indexOf(s) > -1; }) : all;
  }
  function chips(group, list, render){
    var wrap = buildStep.querySelector('[data-group="' + group + '"]');
    wrap.innerHTML = '';
    list.forEach(function(o){
      var b = document.createElement('button'); b.type = 'button';
      b.className = 'saro-tryon__chip' + (group === 'skin' ? ' saro-tryon__chip--swatch' : '');
      b.dataset.value = o[0];
      b.setAttribute('aria-pressed', pick[group] === o[0] ? 'true' : 'false');
      render(b, o);
      b.addEventListener('click', function(){
        pick[group] = o[0];
        if (group === 'gender') { delete pick.shape; delete pick.height; delete pick.size; drawBuild(); }
        else wrap.querySelectorAll('.saro-tryon__chip').forEach(function(c){ c.setAttribute('aria-pressed', c.dataset.value === o[0] ? 'true' : 'false'); });
        buildReady();
      });
      wrap.appendChild(b);
    });
  }
  function drawBuild(){
    var g = pick.gender;
    buildStep.querySelector('.saro-tryon__bgender').hidden = !unisex;
    chips('gender', [['woman','Woman'],['man','Man']], function(b, o){ b.textContent = o[1]; });
    chips('shape', B_OPTS.shape[g], function(b, o){ b.textContent = o[1]; });
    chips('height', B_OPTS.height[g], function(b, o){ b.innerHTML = o[1] + '<small>' + o[2] + '</small>'; });
    chips('skin', B_OPTS.skin, function(b, o){ b.style.background = o[1]; b.setAttribute('aria-label', 'Skin tone ' + o[0].slice(1) + ' of 6'); });
    chips('hair', B_OPTS.hair, function(b, o){ b.textContent = o[1]; });
    chips('size', sizeList().map(function(s){ return [s]; }), function(b, o){ b.textContent = o[0]; });
    buildReady();
  }
  function buildReady(){
    $('.saro-tryon__bgo').disabled = !['shape','height','skin','hair','size'].every(function(k){ return pick[k]; });
  }
  function openBuild(){
    mode = 'model'; sentBlur = false; sentBoxes = [];
    if (!unisex) pick.gender = 'woman';
    var saved = recall('saro_usual_size');
    if (saved && !pick.size && sizeList().indexOf(normSize(saved)) > -1) pick.size = normSize(saved);
    drawBuild();
    show('build');
  }
  if (buildStep) $('.saro-tryon__bgo').addEventListener('click', function(){
    var choice = { gender: pick.gender, shape: pick.shape, height: pick.height, skin: pick.skin, hair: pick.hair, size: pick.size };
    loading('Creating your model…', 'This can take up to a minute. Next time it will be instant.');
    post('/model', choice)
      .then(function(d){
        if (d.status === 'completed' && d.output) return d.output;
        if (!d.id) throw d.error;
        return poll(d.id, 90);
      })
      .then(function(out){
        var model = asDataUrl(out);
        store('saro_person', model); store('saro_person_meta', '{}');
        track('saro_model_built');
        runTryOn(model);
      })
      .catch(function(err){ fail(typeof err === 'string' ? err : 'We couldn\'t create this model. Please try again.'); });
  });

  // --- 3. Try-on
  function runTryOn(person){
    if (!person) return show('choose');
    loading('Styling your look…', 'This can take up to a minute.');
    stopBlurred();
    post('/tryon', { photo: person, garment: garment, consent: consentRecord() })
      .then(function(d){ if (!d.id) throw d.error; return poll(d.id, 90); })
      .then(function(out){ return sentBlur ? reblur(asDataUrl(out), sentBoxes) : asDataUrl(out); })
      .then(function(out){
        lookImg = out; videoUrl = null;
        $('.saro-tryon__result').src = lookImg;
        $('.saro-tryon__save').href = lookImg;
        setView('photo'); $('.saro-tryon__videomsg').hidden = true;
        show('result'); track('saro_try_on_completed');
        root.dispatchEvent(new CustomEvent('saro:look', { detail: { styled: false } }));
      })
      .catch(function(err){ fail(typeof err === 'string' ? err : null); });
  }

  // Hooks for the "Style my look" add-on
  root.saroGetLook = function(){ return lookImg; };
  root.saroSetLook = function(img){
    lookImg = img; videoUrl = null; stopBlurred();
    $('.saro-tryon__result').src = img; $('.saro-tryon__save').href = img;
    setView('photo'); $('.saro-tryon__videomsg').hidden = true;
    root.dispatchEvent(new CustomEvent('saro:look', { detail: { styled: true } }));
  };

  // --- 4. Photo / See it move
  function videoProgress(){
    var box = $('.saro-tryon__vload'), fill = $('.saro-tryon__fill'), pct = $('.saro-tryon__vload-pct'), sub = $('.saro-tryon__vload-sub'), bar = $('.saro-tryon__track');
    var steps = ['Sending your look to our studio…', 'Animating the fabric…', 'Adding natural movement…', 'Polishing the final frames…', 'Almost there, thanks for waiting…'];
    var t0 = Date.now(); box.hidden = false;
    $('.saro-tryon__media').scrollIntoView({ behavior:'smooth', block:'start' });
    function tick(){
      var s = (Date.now() - t0) / 1000, p = Math.min(95, 95 * (1 - Math.exp(-s / 45)));
      fill.style.width = p + '%'; pct.textContent = Math.round(p) + '%'; bar.setAttribute('aria-valuenow', Math.round(p));
      sub.textContent = steps[Math.min(steps.length - 1, Math.floor(s / 20))] + ' This can take up to 2 minutes, please keep this window open.';
    }
    tick(); var iv = setInterval(tick, 500);
    return function(done){
      clearInterval(iv);
      if (done) { fill.style.width = '100%'; pct.textContent = '100%'; setTimeout(function(){ box.hidden = true; }, 500); }
      else box.hidden = true;
    };
  }
  function setView(v){
    root.querySelectorAll('.saro-tryon__tab').forEach(function(t){ t.classList.toggle('is-active', t.dataset.view === v); });
    var img = $('.saro-tryon__result'), vid = $('.saro-tryon__video');
    img.hidden = v !== 'photo';
    if (v === 'video' && sentBlur) { playBlurred(); vid.play().catch(function(){}); return; }
    stopBlurred(); vid.hidden = v !== 'video';
    if (v === 'video') { vid.play().catch(function(){}); } else { vid.pause(); }
  }
  root.querySelectorAll('.saro-tryon__tab').forEach(function(tab){
    tab.addEventListener('click', function(){
      if (tab.dataset.view === 'photo') return setView('photo');
      if (videoUrl) return setView('video');
      var msg = $('.saro-tryon__videomsg'), vid = $('.saro-tryon__video');
      msg.hidden = true; tab.disabled = true;
      var stop = videoProgress();
      post('/video', { image: lookImg })
        .then(function(d){ if (!d.id) throw d.error; return poll(d.id, 140); })
        .then(function(out){
          videoUrl = out;
          // With blur on we read the frames to find faces, which needs a CORS-enabled video; fall back if the CDN refuses
          if (sentBlur) vid.crossOrigin = 'anonymous'; else vid.removeAttribute('crossorigin');
          vid.src = out;
          return new Promise(function(res){
            var retried = false;
            vid.oncanplay = res;
            vid.onerror = function(){ if (sentBlur && !retried) { retried = true; vid.removeAttribute('crossorigin'); vid.src = out; vid.load(); } else res(); };
            setTimeout(res, 10000); vid.load();
          });
        })
        .then(function(){ stop(true); setView('video'); track('saro_try_on_video'); })
        .catch(function(){ stop(false); msg.hidden = false; msg.textContent = 'We couldn\'t make the video this time. Please try again.'; })
        .then(function(){ tab.disabled = false; });
    });
  });

  // --- Find my size
  var usual = $('.saro-tryon__usual');
  sizes.forEach(function(s){ var o = document.createElement('option'); o.value = s; o.textContent = s; usual.appendChild(o); });
  if (!sizes.length) $('.saro-tryon__size').hidden = true;
  if (kids) { $('.saro-tryon__h2').hidden = true; $('.saro-tryon__usual').options[0].textContent = 'Their size'; }
  function recommend(){
    var rec = $('.saro-tryon__rec'), i = sizes.indexOf(usual.value);
    if (i < 0) { rec.hidden = true; return; }
    var pick = i, note = 'This style fits true to size.';
    if (fit === 'small') { pick = Math.min(i + 1, sizes.length - 1); note = 'This style runs small, so we suggest one size up.'; }
    if (fit === 'large') { pick = Math.max(i - 1, 0); note = 'This style runs large, so we suggest one size down.'; }
    var h = kids ? 0 : parseInt($('.saro-tryon__h2').value, 10), len = '';
    if (h && h < 160) len = ' At ' + h + 'cm, the hem may sit a little longer than shown.';
    if (h && h > 175) len = ' At ' + h + 'cm, the hem may sit a little shorter than shown.';
    rec.innerHTML = 'We recommend <strong>' + sizes[pick] + '</strong>. ' + note + len;
    rec.hidden = false;
    try { store('saro_usual_size', usual.value); } catch(e){}
  }
  usual.addEventListener('change', recommend);
  $('.saro-tryon__h2').addEventListener('input', recommend);
  var saved = recall('saro_usual_size'); if (saved && sizes.indexOf(saved) > -1) { usual.value = saved; }

  // --- Actions
  root.querySelectorAll('.saro-tryon__again').forEach(function(b){
    b.addEventListener('click', function(){ history = []; stopBlurred(); if (kids) return selectMode('body'); store('saro_person', null); store('saro_person_meta', null); $('.saro-tryon__reuse').hidden = true; show('choose'); });
  });
  $('.saro-tryon__shop').addEventListener('click', function(){
    close();
    var i = sizes.indexOf(usual.value);
    var picker = document.querySelector('product-form, form[action*="/cart/add"], .variant-wrapper');
    if (picker) picker.scrollIntoView({ behavior:'smooth', block:'center' });
  });
}
document.querySelectorAll('.saro-tryon[data-api]').forEach(initTryOn);
// Load the "Style my look" add-on for adult products
if (window.SARO_TRYON_ASSETS && document.querySelector('.saro-tryon[data-kids="false"]') && !document.getElementById('saro-tryon-style-js')) {
  var sx = document.createElement('script'); sx.id = 'saro-tryon-style-js'; sx.defer = true;
  sx.src = window.SARO_TRYON_ASSETS + 'saro-tryon-style.js';
  document.head.appendChild(sx);
}
})();
